import { ETabId } from '../../services/tab-configurations/tab-types';
import { TPaymentPartition, TPaymentPartitionGroup } from '../api-ducks/earnings-duck/types-earnings';

// Filter Duck Type
export type TFilters = {
  activeTab?: ETabId;
  participationId?: number;
  personnelNumber?: number;
  selectedParticipationPartitionGroup?: TPartitionGroup; // Fiscal Year - cadence
  selectedParticipationPartition?: TPartition; // Semester - Quarter
  selectedPerformancePartitionGroup?: TPartitionGroup; // Fiscal Year - cadence
  selectedPerformancePartition?: TPartition; // Semester - Quarter - Month
  selectedManagerPartitionGroup?: TPartitionGroup; // Fiscal Year - cadence
  selectedManagerPartition?: TPartition; // Semester - Quarter - Month
  selectedPaymentPartitionGroup?: TPaymentPartitionGroup; // Fiscal Year - cadence
  selectedPaymentPartition?: TPaymentPartition; // Semester - Quarter - Month
  availablePaymentPartitions?: TPaymentPartitionGroup[]; // We are using this place to dynamically construct the available payment partitions.
};

// Filters to be added on url params
export type TFilterParams = {
  fiscalYearId?: string;
  fiscalSemesterId?: number;
  fiscalQuarterId?: number;
  fiscalMonthId?: number;
  participationId?: number;
  personnelNumber?: number;
  endDate?: string;
  startDate?: string;
  defaultFiscalYearId?: number;
};

export type TPartitionGroup = {
  partitionGroup?: string;
  partitionCadence?: EPartitionCadence;
  partitions: TPartition[];
};

export type TPartition = {
  order: number; // fiscalSemesterId, or fiscalQuarterId, or fiscalMonthId
  title: string;
  startDate: string;
  endDate: string;
};

export enum EPartitionCadence {
  Quarterly = 'Quarterly',
  Monthly = 'Monthly',
  SemiAnnual = 'Semi-Annual',
  Unknwon = 'Unknown',
}
